import React, { useEffect, useMemo, useState } from 'react'
import { AuthenticateDocument } from '../../utils/AuthenticateDocument';
import MainLayout from '../MainLayout';
import External from '../ExternalUser';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { useParams } from 'react-router-dom';
import { hasCachedDocument } from '../../utils/documentCache';
import { getLocalGrid, isLocalGridRoute } from '../../utils/localGrids';

const MileGrid = ({ isExternal = false, isTemplateDocument = false }) => {

    const { id } = useParams();
    const { conflictPreviewVerion, setConflictPreviewVerion, setIsReadOnly, setIsTemplateDocument, setDocumentInfo, setIsAuthenticated } = useDocument();
    const [isAuthenticating, setIsAuthenticating] = useState(true);

    // Local (offline-created) grids have no server counterpart, so they skip the
    // auth gate entirely. Flagged by ?local=true.
    const isLocalGrid = useMemo(() => isLocalGridRoute(), []);

    // Cached documents render instantly (no auth loader); only non-templates cache.
    const isDocumentCached = useMemo(
        () => !isTemplateDocument && hasCachedDocument(id),
        [id, isTemplateDocument]
    );

    useEffect(() => {
        setIsTemplateDocument(isTemplateDocument);
        const searchParams = new URLSearchParams(document.location.search)
        const previewVerion = searchParams.get("versionType");
        if (previewVerion) {
            setConflictPreviewVerion(previewVerion);
            setIsReadOnly(true);
        }

    }, [id]);

    // Seed document info for local grids so the header renders straight away
    // without an auth call. Owner-level rights, no members.
    useEffect(() => {
        if (!isLocalGrid) return;
        const record = getLocalGrid(id);
        if (!record) return;
        setDocumentInfo({
            id: record.id,
            name: record.name,
            creator: record.creator,
            createBy: record.creator?.userId || record.creator?.id,
            members: [],
            privacyId: 1,
            rightType: 2,
            isLocal: true,
        });
        setIsAuthenticated(true);
    }, [isLocalGrid, id]);

    return (
        <div className='App'>
            {isExternal ? (
                <External />
            ) : isLocalGrid ? (
                /* Local grid: no auth gate, no fetch — render the editor straight away. */
                <MainLayout />
            ) : isAuthenticating && !conflictPreviewVerion && !isDocumentCached ? (
                <AuthenticateDocument setIsLoading={setIsAuthenticating} />
            ) : (
                <>
                    {/* Fresh loads follow the splash, so the document fades in
                        rather than snapping; a cached doc is already on screen. */}
                    <div className={isDocumentCached ? undefined : "app-content-fade-in"}>
                        <MainLayout />
                    </div>
                    {/* Cached doc: authenticate in the background (no loader) while cached data shows. */}
                    {isDocumentCached && isAuthenticating && !conflictPreviewVerion && (
                        <AuthenticateDocument setIsLoading={setIsAuthenticating} background />
                    )}
                </>
            )}
        </div>
    )
}

export default MileGrid;